module.exports = __webpack_public_path__ + "static/media/altius.f1b9c6ae.svg";